import httpInstances from '@/api/axiosInstance';
import type { SymbolKey } from '@/entities/symbol';
import type { ExportItemType } from '@/features/DataHub/types/pastExports';

type PastExportsResponse = Record<string, ExportItemType>;

export type PastExportDetails = {
  name: string;
  type: string;
  exportSubType: string | null;
  exportTimestamp: number;
  dateFormat: string;
  from: string;
  to: string;
  metadata: string;
  timezone: string;
  symbols: SymbolKey[];
};

const mapSymbols = (symbols: ExportItemType['symbols']): SymbolKey[] => {
  return symbols.map(symbol => ({
    Code: symbol.key.code,
    Period: symbol.key.period,
    TimeRef: symbol.key.timeRef,
    PeriodType: symbol.key.periodType
  }));
};

export const mapExportItemToDetails = (item: ExportItemType): PastExportDetails => {
  return {
    name: item.name,
    type: item.exportType,
    exportSubType: item.exportSubType,
    exportTimestamp: item.lastExecutionTime,
    dateFormat: item.exportSettings.dateFormat,
    from: item.exportSettings.from,
    to: item.exportSettings.to ?? '',
    metadata: item.exportSettings.includeMetadata ? 'true' : 'false',
    timezone: item.exportSettings.timezone,
    symbols: mapSymbols(item.symbols)
  };
};

export const pastExportsApi = {
  async fetchPastExports() {
    const response = await httpInstances.axiosInternalInstance.get<PastExportsResponse>(
      '/config/gxgo_export',
      { validateStatus: status => status === 200 || status === 404 }
    );

    if (response.status === 404) {
      return [];
    }

    return Object.values(response.data).filter(exp => exp.name);
  },
  deletePastExport(exportId: string) {
    return httpInstances.axiosInternalInstance.delete(`/config/gxgo_export/${exportId}`);
  }
};
